var _rect, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReset(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_450_8821",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 20,
    height: 20
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_450_8821)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10.8333 17.5C9.80556 17.5 8.84375 17.309 7.94792 16.9271C7.05208 16.5451 6.26389 16.0208 5.58333 15.3542L6.77083 14.1667C7.29861 14.6806 7.90972 15.0868 8.60417 15.3854C9.29861 15.684 10.0417 15.8333 10.8333 15.8333C12.4444 15.8333 13.8194 15.2639 14.9583 14.125C16.0972 12.9861 16.6667 11.6111 16.6667 10C16.6667 8.38889 16.0972 7.01389 14.9583 5.875C13.8194 4.73611 12.4444 4.16667 10.8333 4.16667C9.22222 4.16667 7.84722 4.73611 6.70833 5.875C5.56944 7.01389 5 8.38889 5 10V10.1458L6.52083 8.625L7.70833 9.79167L4.16667 13.3333L0.625 9.79167L1.8125 8.625L3.33333 10.1667V10C3.33333 8.95833 3.53125 7.98264 3.92708 7.07292C4.32292 6.16319 4.85764 5.37153 5.53125 4.69792C6.20486 4.02431 6.99653 3.48958 7.90625 3.09375C8.81597 2.69792 9.79167 2.5 10.8333 2.5C11.875 2.5 12.8507 2.69792 13.7604 3.09375C14.6701 3.48958 15.4618 4.02431 16.1354 4.69792C16.809 5.37153 17.3438 6.16319 17.7396 7.07292C18.1354 7.98264 18.3333 8.95833 18.3333 10C18.3333 12.0833 17.6042 13.8542 16.1458 15.3125C14.6875 16.7708 12.9167 17.5 10.8333 17.5ZM9.16667 13.3333C8.93056 13.3333 8.73264 13.2535 8.57292 13.0938C8.4132 12.934 8.33333 12.7361 8.33333 12.5V10C8.33333 9.76389 8.4132 9.56597 8.57292 9.40625C8.73264 9.24653 8.93056 9.16667 9.16667 9.16667V8.33333C9.16667 7.875 9.32986 7.48264 9.65625 7.15625C9.98264 6.82986 10.375 6.66667 10.8333 6.66667C11.2917 6.66667 11.684 6.82986 12.0104 7.15625C12.3368 7.48264 12.5 7.875 12.5 8.33333V9.16667C12.7361 9.16667 12.934 9.24653 13.0938 9.40625C13.2535 9.56597 13.3333 9.76389 13.3333 10V12.5C13.3333 12.7361 13.2535 12.934 13.0938 13.0938C12.934 13.2535 12.7361 13.3333 12.5 13.3333H9.16667ZM10 9.16667H11.6667V8.33333C11.6667 8.09722 11.5868 7.89931 11.4271 7.73958C11.2674 7.57986 11.0694 7.5 10.8333 7.5C10.5972 7.5 10.3993 7.57986 10.2396 7.73958C10.0799 7.89931 10 8.09722 10 8.33333V9.16667Z",
    fill: "#4B4B4B"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.ab5967d5d2d8c447d4eb5bab725f65e5.svg";
export { ForwardRef as ReactComponent };